import {DynamicTable} from '../../../../components/DynamicTable'
import {inquiryDetailsTableColumns} from '../../utils'
import InquiryDetailsTableRow from './InquiryDetailsTableRow'

const InquiryDetailsTable = ({isParentRow, productVariants, isOperationLoading}: any) => {
  return (
    <div className='popup-inquiry-table'>
      <DynamicTable
        data={productVariants}
        sortableColumns={inquiryDetailsTableColumns(isParentRow)}
        loading={isOperationLoading}
        tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'
        TableRow={InquiryDetailsTableRow}
        tableRowProps={{isParentRow}}
      />
    </div>
  )
}
export default InquiryDetailsTable
